module.exports = __webpack_public_path__ + "static/media/clock-icon.dfd780ce.svg";